var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.023 9.653c-.432 0-.801-.186-1.048-.495L.874 2.222C.442 1.726.504.983.997.612 1.49.24 2.167.24 2.599.735l5.3 6.07c.062.061.124.061.247 0l5.3-6.07A1.097 1.097 0 0115.05.673c.431.434.493 1.115.123 1.61L9.132 9.22c-.308.247-.678.433-1.11.433z",
    clipRule: "evenodd"
  })));
}
export default SvgIconDown24;